'use strict'

import { loadComponent } from './utils/load-component';
import zonedDate from '../utils/zoned-date';
import { format } from 'date-fns';

const now = zonedDate();

loadComponent('digital-concert', {
    props: {
        concert: {
            type: Object,
        },
    },

    data() {
        const date = zonedDate(this.concert.first_aired);

        return {
            ViewModel: {
                ID: this.concert.id,
                Type: this.concert.type,
                Link: this.concert.url,
                Prefix: this.concert.prefix,
                Title: this.concert.title,
                Date: format(date, 'MMM d, yyyy'),
                RunningTime: this.concert.duration,
                ListingImage: this.concert.image,
                IsPastEvent: now > date,
            },
        };
    },
});
